export default __webpack_public_path__ + "static/media/00_menuOpen.534fbca9.svg";